import React, { useState, useEffect } from 'react';
import api from '../../api';       
import config from '../../config';
import { FaHome, FaSave, FaCheckCircle, FaImage, FaEdit } from 'react-icons/fa';
import styles from './Admin.module.css'; 

const AdminHeroSettings = () => {
  // --- State Management ---
  const [formData, setFormData] = useState({
    badgeText: '',
    titlePrefix: '',
    titleHighlight: '',
    titleSuffix: '',
    subtitle: '',
    stat1: '',
    stat2: '',
    stat3: '',
    stat4: '',
    imageFile: null // New file upload ke liye
  });

  const [currentImageUrl, setCurrentImageUrl] = useState(''); // Existing image show karne ke liye
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });



  // --- 1. Fetch Current Data ---
  useEffect(() => {
    fetchHeroSettings();
  }, []);

  const fetchHeroSettings = async () => {
    try {
      const res = await api.get('/Hero');
      if (res.data) {
        setFormData({
          badgeText: res.data.badgeText || '',
          titlePrefix: res.data.titlePrefix || '',
          titleHighlight: res.data.titleHighlight || '',
          titleSuffix: res.data.titleSuffix || '',
          subtitle: res.data.subtitle || '',
          stat1: res.data.stat1_Count || '',
          stat2: res.data.stat2_Capacity || '',
          stat3: res.data.stat3_Experience || '',
          stat4: res.data.stat4_Satisfaction || '',
          imageFile: null
        });
        setCurrentImageUrl(res.data.backgroundImageUrl);
      }
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };

  // --- 2. Handle Input Change ---
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- 3. Handle File Change ---
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Size Validation (5MB)
      if (file.size > 5 * 1024 * 1024) {
        setMessage({ text: "Image too large! Max 5MB.", type: "error" });
        return;
      }
      setFormData({ ...formData, imageFile: file });
    }
  };

  // --- 4. Submit Form ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    // FormData banana padega kyunki File upload hai
    const data = new FormData();
    data.append('BadgeText', formData.badgeText);
    data.append('TitlePrefix', formData.titlePrefix);
    data.append('TitleHighlight', formData.titleHighlight);
    data.append('TitleSuffix', formData.titleSuffix);
    data.append('Subtitle', formData.subtitle);
    data.append('Stat1_Count', formData.stat1);
    data.append('Stat2_Capacity', formData.stat2);
    data.append('Stat3_Experience', formData.stat3);
    data.append('Stat4_Satisfaction', formData.stat4);

    if (formData.imageFile) {
      data.append('BackgroundImageFile', formData.imageFile);
    }

    try {
      const token = localStorage.getItem('token');
     const res = await api.post('/Hero', data, {
  headers: { 
    'Content-Type': 'multipart/form-data'
  }
});

      setMessage({ text: "Hero Section Updated Successfully!", type: "success" });
      
      // Update Preview if new image was uploaded
      if(res.data.data && res.data.data.backgroundImageUrl) {
        setCurrentImageUrl(res.data.data.backgroundImageUrl);
      }
      
    } catch (err) {
      setMessage({ text: "Update Failed! Please try again.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Container using existing CSS Module class */}
      <div className={styles.formCard} style={{ maxWidth: '800px' }}>
        
        <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaHome /> Update Home Hero Section
        </h3>

        {/* Message Alert */}
        {message.text && (
          <div style={{
            padding: '12px', marginBottom: '20px', borderRadius: '8px',
            background: message.type === 'error' ? 'rgba(239, 68, 68, 0.15)' : 'rgba(74, 222, 128, 0.15)',
            color: message.type === 'error' ? '#fca5a5' : '#4ade80',
            border: message.type === 'error' ? '1px solid rgba(239, 68, 68, 0.3)' : '1px solid rgba(74, 222, 128, 0.3)',
            display: 'flex', alignItems: 'center', gap: '8px'
          }}>
            {message.type === 'success' && <FaCheckCircle />}
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          
          {/* --- Section 1: Main Text Content --- */}
          <h4 style={{ color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px', marginBottom: '15px' }}>
            <FaEdit style={{ marginRight: '8px', color: '#94a3b8' }} />
            Text Content
          </h4>

          <div className={styles.formGroup}>
            <label>Top Badge Text</label>
            <input type="text" name="badgeText" value={formData.badgeText} onChange={handleInputChange} className={styles.formInput} placeholder="e.g. ⚡ PM Suryaghar Yojana" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div className={styles.formGroup}>
              <label>Title Prefix (Normal)</label>
              <input type="text" name="titlePrefix" value={formData.titlePrefix} onChange={handleInputChange} className={styles.formInput} />
            </div>
            <div className={styles.formGroup}>
              <label style={{ color: '#4ade80' }}>Title Highlight (Green Text)</label>
              <input type="text" name="titleHighlight" value={formData.titleHighlight} onChange={handleInputChange} className={styles.formInput} style={{ borderColor: 'rgba(74, 222, 128, 0.5)' }} />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label>Title Suffix (Bottom Line)</label>
            <input type="text" name="titleSuffix" value={formData.titleSuffix} onChange={handleInputChange} className={styles.formInput} />
          </div>

          <div className={styles.formGroup}>
            <label>Subtitle / Description</label>
            <textarea 
              name="subtitle" 
              value={formData.subtitle} 
              onChange={handleInputChange} 
              className={styles.formInput} 
              rows="3"
              style={{ resize: 'vertical' }}
            />
          </div>

          {/* --- Section 2: Stats Numbers --- */}
          <h4 style={{ color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px', marginBottom: '15px', marginTop: '20px' }}>
            <FaEdit style={{ marginRight: '8px', color: '#94a3b8' }} />
            Statistics Numbers
          </h4>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '15px' }}>
            <div className={styles.formGroup}>
              <label>Installations</label>
              <input type="text" name="stat1" value={formData.stat1} onChange={handleInputChange} className={styles.formInput} placeholder="e.g. 500+" />
            </div>
            <div className={styles.formGroup}>
              <label>Capacity</label>
              <input type="text" name="stat2" value={formData.stat2} onChange={handleInputChange} className={styles.formInput} placeholder="e.g. 5MW+" />
            </div>
            <div className={styles.formGroup}>
              <label>Experience</label>
              <input type="text" name="stat3" value={formData.stat3} onChange={handleInputChange} className={styles.formInput} placeholder="e.g. 8+" />
            </div>
            <div className={styles.formGroup}>
              <label>Satisfaction</label>
              <input type="text" name="stat4" value={formData.stat4} onChange={handleInputChange} className={styles.formInput} placeholder="e.g. 100%" />
            </div>
          </div>

          {/* --- Section 3: Background Image --- */}
          <h4 style={{ color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px', marginBottom: '15px', marginTop: '20px' }}>
            <FaImage style={{ marginRight: '8px', color: '#94a3b8' }} />
            Background Image
          </h4>

          <div className={styles.formGroup}>
            <label>Upload New Background (Optional)</label>
            <input type="file" onChange={handleFileChange} className={styles.formInput} accept="image/*" />
            <small style={{ color: '#64748b' }}>Leave empty to keep current image.</small>
          </div>

          {/* Current Image Preview */}
          {currentImageUrl && (
            <div style={{ marginBottom: '20px', padding: '10px', background: 'rgba(0,0,0,0.2)', borderRadius: '8px' }}>
              <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginBottom: '5px' }}>Current Background:</p>
              <img 
                src={currentImageUrl.startsWith('http') ? currentImageUrl : `${config.IMG_BASE_URL}${currentImageUrl}`}
                alt="Current Hero Bg" 
                style={{ width: '100%', maxHeight: '150px', objectFit: 'cover', borderRadius: '5px', border: '1px solid rgba(255,255,255,0.1)' }} 
              />
            </div>
          )}

          {/* Submit Button */}
          <button type="submit" className={styles.primaryBtn} disabled={loading} style={{ marginTop: '10px' }}>
            {loading ? 'Saving Changes...' : <><FaSave /> Update Hero Section</>}
          </button>

        </form>
      </div>
    </div>
  );
};

export default AdminHeroSettings;